import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useUser from "../hooks/useUser";
import useDb from "../hooks/useDb";

const WorkOffline = (props) => {
  const [users, setUsers] = useState([]);
  const { register, handleSubmit } = useForm();
  const { setUser } = useUser();
  const db = useDb();

  const handleWorkOffline = async (data) => {
    const user = await db.users.get({ _id: data.userId });
    setUser(user);

    if (props.handleWorkOffline) {
      props.handleWorkOffline();
    }
  };

  useEffect(() => {
    db.users.toArray().then((_users) => {
      setUsers(_users);
    });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h3>
        {!!users.length
          ? "Select a user below to work offline"
          : "No previously logged in users available."}
      </h3>
      <form onSubmit={handleSubmit(handleWorkOffline)}>
        <select name="userId" ref={register}>
          {users.map((user) => (
            <option key={user._id} value={user._id}>
              {user.firstName} {user.lastName}
            </option>
          ))}
        </select>
        <button type="submit">select</button>
      </form>
    </>
  );
};

export default WorkOffline;
